<div class="pa-expand-block">
    <div class="pa-expand" role="tablist" [class.pa-expand-full]="large">
        <ng-content></ng-content>
    </div>
</div>